(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/page-menu/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/page-menu/prescript.js');
'use strict';

svs.accountservices = svs.accountservices || {};
svs.accountservices.pageMenu = svs.accountservices.pageMenu || {};

 })(window);